// app/metadata.ts
import type { Metadata } from "next";

export const metadata: Metadata = {
  title: "InfraQ",
  description: "An app for construction inspection workflows",
};